module.exports = [
    {
        title: '重要通知',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 39,
        },
        data: [],
        target: 'HtmlPage',
    },
    {
        title: '工作动态',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 2,
        },
        data: [],
        target: 'HtmlPage',
    },
    {
        title: '综合新闻',
        listApi: '/app/portal/cmsXinXi/pageList',
        detailApi: '/app/portal/cmsXinXi/detail',
        dateTitle: '发起时间',
        params: {
            xinXiGuanLiType: 24,
        },
        data: [],
        target: 'HtmlPage',
    },
]
